const _version = "2.10.5"
function version() {
    return _version
}
export default version
